import { createAsyncThunk } from '@reduxjs/toolkit';

import { carAPI } from '@/modules/car/api';
import { VehicleCreateForm } from '@/modules/car/model/car-form';
import { namespace } from '@/modules/car/namespace';
import { getCarForm } from '@/modules/car/store/selectors';
import { RootState } from '@/root-store';
import { ThunkResult } from '@/shared/actions/thunk-result';
import { ISubmitFormResult } from '@/shared/models/formSubmit';

import { setCar, updateForm } from '../actions';

let lastRequestId: string | undefined;

interface IParams {
  formValues: VehicleCreateForm;
  onSuccess?: (id: string) => void;
}

const createCar = createAsyncThunk(
  `${namespace}/create-car`,
  async (
    { onSuccess, formValues }: IParams,
    { getState, dispatch, requestId },
  ): Promise<ThunkResult<ISubmitFormResult<VehicleCreateForm>>> => {
    lastRequestId = requestId;

    const carId = getCarForm(getState() as RootState).id;
    const [updatedCar, serverValidation] = await (carId
      ? carAPI.updateCar({
          id: carId,
          ...formValues,
        })
      : carAPI.createCar(formValues));

    if (lastRequestId !== requestId) {
      return { isReplaced: true };
    }

    if (serverValidation) {
      return {
        isSucceed: false,
        result: {
          validationErrors: serverValidation,
        },
      };
    }

    dispatch(updateForm(updatedCar));
    dispatch(setCar(updatedCar));

    onSuccess?.(updatedCar.id);

    return { isSucceed: true };
  },
);

export { createCar };
